// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconCheckmarkPath = 'M17.704 2.19 7.429 15.302l-5.295-5.295L.72 11.421l6.092 6.093a.998.998 0 0 0 .707.293l.061-.002c.285-.017.55-.156.727-.381l10.971-14-1.574-1.234Z';
var IconCheckmark = baseIcon('IconCheckmark', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconCheckmarkPath
});
export default IconCheckmark;
//# sourceMappingURL=index.js.map